import AppDialog from "./AppDialog";
import PreviewContent from "./PreviewContent";
import { useTran } from "@/hooks";

const PreviewModal = ({
  open,
  onOpenChange,
  title,
  description,
  content,
  loading = false,
  error = "",
  emptyMessage,
  footer,
  size = "3xl",
  contentClassName = "bg-background",
}) => {
  const { t } = useTran();
  const resolvedTitle = title ?? t("Preview");
  const resolvedDescription =
    description ?? t("Review the current preview content.");

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title={resolvedTitle}
      description={resolvedDescription}
      size={size}
      contentClassName={contentClassName}
      footer={footer}
    >
      <PreviewContent
        content={content}
        loading={loading}
        error={error}
        emptyMessage={emptyMessage}
      />
    </AppDialog>
  );
};

export default PreviewModal;
